import * as React from "react"
import {Skeleton} from "@mui/material";
import {useComputed} from "@preact/signals-react";

import {RepricingTable} from "../@components";
import {useRepricingNotifications} from "./@hooks";
import {repricingIsLoadingNotifications, repricingNotificationsType} from "../@signals";
import {NOTIFICATIONS_TYPE} from "../@constants";


export default function RepricingNotifications() {
	const { notifications } = useRepricingNotifications()
	const isNotificationHistory = useComputed(() => repricingNotificationsType.value === NOTIFICATIONS_TYPE.NOTIFICATION)


	if (repricingIsLoadingNotifications.value)
		return <Skeleton height={500} variant="rectangular" />

	return <RepricingTable
		title={`${isNotificationHistory.value ? 'Notifications' : 'Repricing'} History`}
		data={notifications}
		showTooltip={false}
		myPriceName="My Price"
		columns={{
			imageSku: true,
			sku: true,
			alertName: true,
			myPrice: true,
			newPrice: !isNotificationHistory.value,
			date: true,
			retailer: true
		}}
	/>

}